import React from "react";
import Banner from "./Banner";



import Carousel from "react-bootstrap/Carousel";
import { Link } from "react-router-dom";
import AdmissionBanner from "./AdmissionBanner";

const Home = () => {
  // const sliderClick = (slider) => { };

  // const slides = [
  //   {
  //     image: "./images/cr1.jpg",
  //     title: "Merry Christmas",
  //     description: "25 December",
  //     clickEvent: sliderClick,
  //   },
  //   {
  //     image: "/images/new1.jpg",
  //     title: "Happy New Year",
  //     description: "01 January ",
  //     clickEvent: sliderClick,
  //   },

  //   {
  //     image: "./images/mk.jpg",
  //     title: "Happy Makar sankranti",
  //     description: "14 January ",
  //     clickEvent: sliderClick,
  //   },

  //   {
  //     image: "./images/rep.jpg",
  //     title: "Republic Day",
  //     description: "26 January",
  //     clickEvent: sliderClick,
  //   },
  //   {
  //     image: "./img/yoga.jpeg",
  //     title: "Happy Mahashivratri",
  //     description: "18 February",
  //     clickEvent: sliderClick,
  //   },
  //   {
  //     image: "./images/fa.jpeg",
  //     title: "Happy Holi",
  //     description: "8 March",
  //     clickEvent: sliderClick,
  //   },

  //   {
  //     image: "./images/g33.jpeg",
  //     title: "Mahavir Jayanti",
  //     description: "4 April ",
  //     clickEvent: sliderClick,
  //   },

  //   {
  //     image: "./img/yoga.jpeg",
  //     title: "Celebrating Yoga Day",
  //     description: "21 june",
  //     clickEvent: sliderClick,
  //   },
  //   {
  //     image: "./img/cultural.jpeg",
  //     title: "Cultural Activity",
  //     description: "yearly",
  //     clickEvent: sliderClick,
  //   },
  // ];
  return (
    <>
      <AdmissionBanner />
      <Banner />
      <div className="new-div">
        <div className="content_box">
          <div className="first_box bxx">


            <h1>Dedication School Of Excellence </h1>

            <div className="image_boxAb img-school">
              <img src="./dedication_school_logo-removebg-preview.png" alt="" />
            </div>

            <div className="para-content">
              <p>
                Dedication School Of Excellence boasts of an enviable, sprawling, serene and beautiful campus with aesthetically designed capacious academic blocks with a mission to create 'enlightened citizens of the world'. The school offers the best opportunities of growth and development.
                <Link to="/ourSchool">read more</Link>
              </p>
            </div>
          </div>
          <div className="second_box bxx">

            <h1>Founder</h1> <br></br>
            <h1>   </h1>

            <div className="image_boxAb img-principle">
              <img src="./principal-image.jpeg" alt="" />
            </div>
            <div className="para-content">
              <p>
                We want to give students wings through education through which they can touch every height. The education provided by us will be the foundation of their future and they will be able to realize their dreams. In the changing times, only bookish knowledge will not suffice, but we will also have to work on the skills of the students
                <Link to="/director"> read more</Link>
              </p>
            </div>
          </div>
          <div className="second_box bxx">

            <h1>Director</h1><br></br>
            <h1>   </h1>

            <div className="image_boxAb img-principle">
              <img src="./director  .jpeg" alt="" />
            </div>
            <div className="para-content">
              <p>
                The education provided by us will not be just traditional education but will be vocational and will make them self-reliant. We assure the parents of the students that the institute will work with full honesty on whatever development is necessary for the children so that they achieve success in social, economic, political etc. fields.
                <Link to="/principal">read more</Link>
              </p>
            </div>
          </div>
          {/* <div className="third_box bxx">
          <div className="bx1">
            <p>Latest From</p>
            <h1>Notice Board</h1>
          </div>

          <div className="image_boxAbc">
            <div className="animatinct" style={{ padding: "5px" }}>
              <p>1. Class Prep Admission Guideline 2023-24</p>
              <p>2. School Transport Arrangement</p>
              <p>3. School Transport Arrangement</p>
              <p>4. School Transport Arrangement</p>
              <p>5. School Transport Arrangement</p>
            </div>
          </div>
        </div> */}
        </div>

        <div className="third_content_box">
          <div className="academic_planner">
            <div className="accontent">
              <p>Academic Planner</p>
            </div>
            <div className="imgggbox1">
              <div className="igg"></div>
            </div>
          </div>
          <div className="academic_planner">
            <div className="accontent">
              <p>Class Room</p>
            </div>
            <div className="imgggbox1 imgggbox12">
              <div className="igg">

              </div>
            </div>
          </div>
          <div className="academic_planner">
            <div className="accontent">
              <p>Republic Day</p>
            </div>
            <div className="imgggbox1 imgggbox13">
              <div className="igg igg1">
                <img src="./gallery9.jpeg" alt="" />
              </div>
            </div>
          </div>
        </div>

        <div className="fourth_content_box">
          <div className="fouthmain">
            <div className="fourthOne">
              <div className="ffone">
                <h3>Photo Gallery</h3>
              </div>
              <div className="ffslider">
                <Carousel className="abcd">
                  <Carousel.Item className="jhk">
                    <img
                      className="d-block"
                      src="./dedication_school_logo-removebg-preview.png"
                      alt="First slide"
                    />
                  </Carousel.Item>
                  <Carousel.Item className="jhk">
                    <img
                      className="d-block"
                      src="./gallery4.jpeg"
                      alt="Second slide"
                    />
                  </Carousel.Item>

                  <Carousel.Item className="jhk">
                    <img
                      className="d-block"
                      src="./gallery1.jpeg"
                      alt="Third slide"
                    />
                  </Carousel.Item>

                  <Carousel.Item className="jhk">
                    <img
                      className="d-block"
                      src="./gallery6.jpeg"
                      alt="Third slide"
                    />
                  </Carousel.Item>

                </Carousel>
              </div>
              <div className="ffbutton">
                <Link to="/gallery">
                  <button>View More</button>
                </Link>
              </div>
            </div>

            {/*
            <div className="fourthOne">
              <div className="ffone">
                <h3>Video Gallery</h3>
              </div>
              <div className="ffslider">
                <iframe
                  width="100%"
                  height="100%"
                  src="https://www.youtube .com/embed/tEMETkbgv1Y?si=DiHUj4RaGeUcbof5"
                  title=" Video Player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowfullscreen
                ></iframe>
              </div>
              <div className="ffbutton">
                <a
                  href="https://www.youtube.com/@newwisdompublicschool2631"
                  target="_blank" rel="noreferrer"
                >
                  <button>View More</button>
                </a>
              </div>
            </div> */}
          </div>
        </div >
      </div >
    </>
  );
};

export default Home;
